import { motion , AnimatePresence } from "framer-motion";
import { Copy, AlertTriangle, Terminal, Trash2, Clock, Shield, Key, ChevronRight, Loader2, Check , X } from 'lucide-react';

const Modal = ({ isOpen, onClose, title, children }) => (
  <AnimatePresence>
    {isOpen && (
      <>
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose} className="fixed inset-0 bg-black/95 backdrop-blur-md z-[100] !mt-0" />
        <motion.div initial={{ opacity: 0, scale: 0.95, y: 20 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.95, y: 20 }} className="fixed w-[92%] max-w-lg top-[10%] left-0 right-0 mx-auto bg-[#0a0a0a] border border-white/10 rounded-[2rem] md:rounded-[2.5rem] shadow-2xl z-[101] overflow-hidden">
          <div className="flex justify-between items-center p-6 md:p-8 border-b border-white/5">
            <h3 className="font-black text-xl tracking-tighter text-white">{title}</h3>
            <button onClick={onClose} className="text-gray-500 hover:text-white p-2 hover:bg-white/5 rounded-full transition-colors"><X size={20} /></button>
          </div>
          <div className="p-6 md:p-10 max-h-[70vh] overflow-y-auto custom-scrollbar">{children}</div>
        </motion.div>
      </>
    )}
  </AnimatePresence>
);

export default Modal